import { render } from "./SmartPreprocessDialog.vue?vue&type=template&id=3bf09a8b&scoped=true"
import script from "./SmartPreprocessDialog.vue?vue&type=script&lang=js"
export * from "./SmartPreprocessDialog.vue?vue&type=script&lang=js"

import "./SmartPreprocessDialog.vue?vue&type=style&index=0&id=3bf09a8b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf09a8b"]])

export default __exports__